export type Endpoint = Partial<URL & { origin: string; deepLink: string }>;
interface Config {
  env: 'production' | 'development' | 'test';
  service: {
    home: Endpoint;
    gateway: Endpoint;
    feApi: Endpoint;
    policySite: Endpoint;
    platformSite: Endpoint;
  };
  aws: {
    identityPoolId: string;
    kinesisStreamName: string;
    region: string;
  };
  tracker: {
    gaId: string;
  };
  naverMapApiKey: string;
}

const config: Config = {
  env: process.env.NODE_ENV,
  service: {
    home: {
      origin: process.env.NEXT_PUBLIC_YANOLJA_ORIGIN,
      deepLink: process.env.NEXT_PUBLIC_DEEP_LINK_YANOLJA_HOME,
    },
    gateway: {
      origin: process.env.NEXT_PUBLIC_FE_GATEWAY_ORIGIN,
    },
    feApi: {
      origin: process.env.NEXT_PUBLIC_FE_API_ORIGIN,
    },
    policySite: {
      origin: process.env.NEXT_PUBLIC_POLICY_SITE_ORIGIN,
    },
    platformSite: {
      origin: process.env.NEXT_PUBLIC_PLATFORM_SITE_ORIGIN,
    },
  },
  aws: {
    identityPoolId: process.env.NEXT_PUBLIC_CREDENTIAL_POOL_ID,
    kinesisStreamName: process.env.NEXT_PUBLIC_KINESIS_STREAM_NAME,
    region: process.env.NEXT_PUBLIC_AWS_REGION,
  },
  tracker: {
    gaId: process.env.NEXT_PUBLIC_GA_ID,
  },
  naverMapApiKey: process.env.NEXT_PUBLIC_NAVER_MAP_API_KEY || '',
};
export default config;
